import React from "react";

export default function LifecycleSummary({ data }) {

  if (!data) return null;

  const currentStock = parseFloat(data?.inventory?.current_stock || 0);
  const totalIssues = data?.consumption?.issues?.length || 0;
  const reservations = data?.reservation?.reservations?.length || 0;
  const totalGRNs = data?.receiving?.grns?.length || 0;

  return (

    <div className="lifecycle-summary">

      <div className="kpi-card">
        <label>Current Stock</label>
        <div className="kpi-value">
          {currentStock.toLocaleString()}
        </div>
      </div>

      <div className="kpi-card">
        <label>Total Issues</label>
        <div className="kpi-value">
          {totalIssues}
        </div>
      </div>

      <div className="kpi-card">
        <label>Reservations</label>
        <div className="kpi-value">
          {reservations}
        </div>
      </div>

      <div className="kpi-card">
        <label>GRNs</label>
        <div className="kpi-value">
          {totalGRNs}
        </div>
      </div>

    </div>

  );

}